module.exports = __webpack_public_path__ + "img/dsci0028.6d6c724f.jpg";